import {Card} from "../../../basic/card.tsx";
import {useTranslationWithKeys} from "../../../../hooks/useTranslationWithKeys";

export function PricingDisclaimer() {
    const {t} = useTranslationWithKeys();

    return (
        <Card className="p-6 shadow-sm border-border/50 bg-accent/30 text-center mt-8">
            <p className="text-muted-foreground">
                {t('pricing.disclaimer')}
            </p>
        </Card>
    );
}